export default "__VITE_ASSET__f88a6551__"